interface Tab<T extends string> { value: T; label: string; count?: number; tone?: string; }

interface Props<T extends string> {
  tabs: Tab<T>[];
  value: T;
  onChange: (v: T) => void;
}

// Underline tab row — used for the desktop thread filter row (3e). The
// sidebar's sub-menus (client filter, internal tabs, tasks filter) use
// SegmentedControl instead, to match the chat window's toggle style.
export default function FilterTabs<T extends string>({ tabs, value, onChange }: Props<T>) {
  return (
    <div style={{ display: 'flex', gap: 18, borderBottom: '1px solid var(--border-subtle)' }}>
      {tabs.map((t) => {
        const active = value === t.value;
        return (
          <button
            key={t.value}
            onClick={() => onChange(t.value)}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '8px 2px', fontSize: '0.78rem', fontWeight: 600,
              color: active ? (t.tone ?? 'var(--text-primary)') : 'var(--shell-xs)',
              borderBottom: active ? `2px solid ${t.tone ?? 'var(--accent)'}` : '2px solid transparent',
              transition: 'color .12s, border-color .12s',
            }}
          >
            {t.label}{typeof t.count === 'number' ? ` ${t.count}` : ''}
          </button>
        );
      })}
    </div>
  );
}
